const viewportUnits = () => {

  const html = document.documentElement;

  const calcViewportUnits = () => {
    const w = Math.min(html.clientWidth, window.innerWidth || 0);
    const h = Math.min(html.clientHeight, window.innerHeight || 0);

    const vh = h * 0.01;
    const vw = w * 0.01;

    html.style.setProperty('--vh', `${vh}px`);
    html.style.setProperty('--vw', `${vw}px`);
  };

  calcViewportUnits.call();
  $(window).on('resize', calcViewportUnits);
};

export default viewportUnits;
